import { forwardRef } from "react";
import { AgGridReact } from "ag-grid-react";
import {
  AllCommunityModule,
  ModuleRegistry,
  themeAlpine,
} from "ag-grid-community";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "./DataGrid.css";

ModuleRegistry.registerModules([AllCommunityModule]);

export const DataGrid = forwardRef((props, ref) => {
  const { gridRef } = props;
  let lastKeyPressed = null;

  return (
    <AgGridReact
      ref={gridRef}
      {...props}
      suppressHeaderFocus={true}
      domLayout="normal"
      className="custom-ag-grid"
      suppressMovableColumns={true}
      enableBrowserTooltips={false}
      suppressScrollOnNewData={true}
      theme={themeAlpine}
      onCellKeyDown={(event) => {
        lastKeyPressed = event.event.key;

        if (lastKeyPressed === "Enter" || lastKeyPressed === "Tab") {
          event.api.stopEditing();
          event.event.preventDefault();
        }
      }}
      onCellEditingStopped={(params) => {
        requestAnimationFrame(() => {
          const api = params.api;
          const columns = api.getAllDisplayedColumns();
          const currentRowIndex = params.rowIndex;
          const currentColIndex = columns.findIndex(
            (col) => col.getColId() === params.column.getColId()
          );

          const isLastCol = currentColIndex === columns.length - 1;
          if (
            isLastCol &&
            (lastKeyPressed === "Enter" || lastKeyPressed === "Tab")
          ) {
            api.setFocusedCell(currentRowIndex, params.column.getColId());
            lastKeyPressed = null;
            return;
          }

          if (lastKeyPressed === "Enter" || lastKeyPressed === "Tab") {
            const nextCol = columns[currentColIndex + 1];
            if (nextCol) {
              api.setFocusedCell(currentRowIndex, nextCol.getColId());
              api.startEditingCell({
                rowIndex: currentRowIndex,
                colKey: nextCol.getColId(),
              });
              lastKeyPressed = null;
              return;
            }
          }

          lastKeyPressed = null;
        });
      }}
    />
  );
});
